import { render, staticRenderFns } from "./UploadFileDialog.vue?vue&type=template&id=4a38f2d3&scoped=true"
import script from "./UploadFileDialog.vue?vue&type=script&lang=js"
export * from "./UploadFileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a38f2d3",
  null
  
)

export default component.exports